import React, { createContext, useContext } from 'react'
import useSheetReview from './useSheetReview'

const SheetReviewContext = createContext(null)

export function SheetReviewProvider({ slug, children }) {
  const reviewState = useSheetReview(slug)
  const value = { ...reviewState, slug }
  return <SheetReviewContext.Provider value={value}>{children}</SheetReviewContext.Provider>
}

export function useSheetReviewContext() {
  const ctx = useContext(SheetReviewContext)
  if (!ctx) {
    throw new Error('useSheetReviewContext must be used within SheetReviewProvider')
  }
  return ctx
}
